webpackJsonp([20],{

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c604b6ec_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__(760);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c604b6ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c604b6ec_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(758);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(34)("5dad8633", content, true);

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".router-link-active[data-v-c604b6ec]{background:#ee7532;color:#fff}", ""]);

// exports


/***/ }),

/***/ 759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "about"
});

/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header other-banner other-banner-about",attrs:{"id":""}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"other-banner-title"},[_vm._v(_vm._s(_vm.$t('about.AboutUs')))])])]),_vm._v(" "),_c('div',{staticClass:"content bgf5f5f5"},[_c('div',[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"container sub-nav about-nav"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{attrs:{"to":"about"}},[_vm._v(_vm._s(_vm.$t('about.CompanyInformation')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"aboutRecruitment"}},[_vm._v(_vm._s(_vm.$t('about.CareerOpportunities')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"aboutContact"}},[_vm._v(_vm._s(_vm.$t('about.ContactUs')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"aboutIntegrity"}},[_vm._v(_vm._s(_vm.$t('clause.compliance')))])],1)])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// resource/js/20.870087d646d0078e7a34.js